<template>
  <GobSection id="preguntas">
    <div class="grid gap-10 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16">
      <h2 class="text-gob-5 leading-tight font-extrabold tracking-gob-tighter text-balance text-main">
        Lo que nos preguntan antes de empezar.
      </h2>

      <div class="border-t border-[#DEE2E6]">
        <details v-for="pregunta in preguntas" :key="pregunta.titulo" class="group border-b border-[#DEE2E6]">
          <summary
            class="flex cursor-pointer list-none items-start justify-between gap-6 py-6 text-gob-2 leading-snug font-bold text-main transition-colors duration-(--duration-gob) ease-gob-out hover:text-primary [&::-webkit-details-marker]:hidden"
          >
            {{ pregunta.titulo }}
            <IconPlus
              class="mt-0.5 size-6 shrink-0 text-primary transition-transform duration-(--duration-gob) ease-gob-out group-open:rotate-45"
              aria-hidden="true"
            />
          </summary>
          <p class="max-w-2xl pb-7 leading-relaxed text-[#495057]">{{ pregunta.respuesta }}</p>
        </details>
      </div>
    </div>
  </GobSection>
</template>

<script>
import { IconPlus } from '@tabler/icons-vue'
import GobSection from '@/components/GobSection.vue'

/*
 * La pregunta sobre el tiempo de implementación queda fuera hasta tener un dato real (decisión D-10).
 */
const PREGUNTAS = [
  {
    titulo: '¿Gob 24/7 reemplaza a SisPT o a la PIIP?',
    respuesta: 'No. Esos sistemas reciben el avance de su entidad cada cierto periodo, cuando ya no hay margen para cambiar el resultado. Gob 24/7 le muestra el avance todos los días, para que corrija a tiempo lo que después va a reportar.'
  },
  {
    titulo: '¿Sirve para un municipio pequeño?',
    respuesta: 'Sí. Trabajamos con entidades de todos los tamaños, desde municipios de categoría especial hasta sexta categoría, con modelos adaptados a cada capacidad presupuestal.'
  },
  {
    titulo: '¿Qué pasa con los datos de los ciudadanos?',
    respuesta: 'Cada funcionario accede solo a la información de su dependencia, según su rol, y cada cambio queda registrado con quién lo hizo y cuándo.'
  },
  {
    titulo: '¿Qué pasa cuando cambia el gobierno?',
    respuesta: 'La información es de la entidad y la historia queda completa. Quien llega encuentra el camino recorrido, no una hoja en blanco.'
  }
]

/**
 * HomePreguntas
 * Preguntas frecuentes que desactivan las objeciones típicas del sector público.
 * Usa <details>/<summary> nativos: teclado y lector de pantalla sin JavaScript.
 */
export default {
  name: 'HomePreguntas',
  components: { GobSection, IconPlus },
  data() {
    return { preguntas: PREGUNTAS }
  }
}
</script>
